import React, { useState, useEffect, useRef } from "react";
// import LandingPage from "../../pages/landingpage/LandingPage";
// import Header from "../header/Header";
import axios from "axios";
import { checkParams } from "../../../src/util/Util";
import { useNavigate } from "react-router-dom";
import "./AddCommunityMember.css";

const AddCommunityMember = (props) => {
  const [errorFirstName] = useState("Please enter a valid name.");
  const [errorLastName] = useState("Please enter a valid last name.");
  const [errorEmail] = useState("Please enter a valid email address.");
  const [errorPhone] = useState("Please enter a valid US mobile number.");
  // eslint-disable-next-line
  const [disableQuest, setDisableQuest] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [memberToDelete, setMemberToDelete] = useState(null);
  const [currentUserEmail, setCurrentUserEmail] = useState();
  // const [errorFirstName, setErrorFirstName] = useState("");
  // const [errorLastName, setErrorLastName] = useState("");
  const [succPopUp, setSuccPopUp] = useState("");
  const [alreadyHasMembers, setAlreadyHasMembers] = useState(false);
  const [alreadyHasMembersLength, setAlreadyHasMembersLenght] = useState(0);
  // const [isInputEmpty, setIsInputEmpty] = useState(true);
  const nav = useNavigate();
  const [isLandingPage, setIsLandingPage] = useState(false);

  const SuccopupRef = useRef(succPopUp);
  useEffect(() => {
    SuccopupRef.current = succPopUp;
    const timeout = setTimeout(() => {
      setSuccPopUp("");
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [succPopUp]);

  useEffect(() => {
    if (props.isLandingPage) {
      setIsLandingPage(true);
    }

    axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
    axios
      .post(window.ajaxLink + "user/checkOtpVerified", {})
      .then((res) => {
        if (res.data.responseData) {
          axios
            .post(window.ajaxLink + "cloud_questionnaires/get-questionnaire", {
              questionnaire_type: "Initial Questionnaire",
            })
            .then((res) => {
              if (res.data.responseData) {
                if (res.data.responseData.disable_quest === 1) {
                  setDisableQuest(true);
                  nav("/landing");
                } else if (res.data.responseData.disable_oneonone === 1) {
                  axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
                  axios
                    .post(window.ajaxLink + "appointments/noAppointmentNotification", {})
                    .then((res) => {
                      if (res.data.responseData) {
                        //console.log("success")
                      }
                    })
                    .catch((error) => {
                      console.error(error);
                    });
                }
              }
            })
            .catch((error) => {
              console.error(error);
            });
        }
      })
      .catch((error) => {
        console.error(error);
      });
      // eslint-disable-next-line
  }, []);

  const [popUp, setPopUp] = useState(false);
  const openClosePopUp = () => {
    setPopUp(!popUp);
    if (popUp === false) {
      setMembers([
        {
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
        },
      ]);
    }
  };

  window.memberPopupOpen = openClosePopUp;

  const [errorPopUp, setErrorPopUp] = useState("");
  const popupRef = useRef(errorPopUp);
  useEffect(() => {
    popupRef.current = errorPopUp;
    const timeout = setTimeout(() => {
      setErrorPopUp("");
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [errorPopUp]);

  const [commPopUp, setCommPopUp] = useState(false);
  const openCloseCommPopUp = () => {
    setCommPopUp(!commPopUp);
  };
// eslint-disable-next-line
  const [addCommLater, setaddCommLater] = useState(false);
  // eslint-disable-next-line
  const addCommunityLater = () => {
    setaddCommLater(true);
    //props.bookAppointmentFromComm();
  };

  const [members, setMembers] = useState([
    {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
    },
  ]);

  const addAnotherMember = () => {
    var newMember = [...members];
    var newMemberSection = {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
    };
    newMember.push(newMemberSection);

    if (members.length >= 3) {
      setErrorPopUp("You have already reached maximum community member count!");
      return false;
    }

    setMembers(newMember);
    setCommPopUp(false);
    setNextStep(false);
  };

  const changeMemberValues = (i, valToChange, value) => {
    if (valToChange === "firstName") {
      value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    } else if (valToChange === "lastName") {
      value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }
    //   if (members[i].firstName === '') {
    //     if (members[i].firstName.length > 10) {
    //     setEditingIndex(i);
    //     setIsInputEmpty(true);
    //   } else {
    //     setEditingIndex(null);
    //     setIsInputEmpty(false);
    //   }
    // }
    // let errorFirst = "";
    // let errorLast = "";
    // if (valToChange === "firstName") {
    //   value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    //   if (value.length < 1 || !checkParams(value, "firstname")) {
    //     errorFirst = "Please enter a valid first name.";
    //   }
    // } else if (valToChange === "lastName") {
    //   value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    //   if (value.length < 1 || !checkParams(value, "lastname")) {
    //     errorLast = "Please enter a valid last name.";
    //   }
    // }
    // setErrorFirstName(errorFirst);
    // setErrorLastName(errorLast);

    var memberChange = [...members];

    if (valToChange === "phone") {
      var phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (phoneRegex.test(value)) {
        var formattedPhoneNumber = value.replace(phoneRegex, "($1)$2-$3");
        value = formattedPhoneNumber;
      }
    }

    memberChange[i][valToChange] = value;
    setMembers(memberChange);
  };

  const checkIsAllFilled = () => {
    for (var member of members) {
      if ((member.firstName.length >= 0 || member.lastName.length >= 0 || member.email.length >= 0 || member.phone.length >= 0) && (member.firstName.length < 2 || !checkParams(member.firstName, "firstname") || member.lastName.length < 2 || !checkParams(member.lastName, "lastname") || !checkParams(member.email, "email") || member.phone.length < 9 || !/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(member.phone))) {
        return false;
      }
    }
    return true;
  };

  const [nextStep, setNextStep] = useState(false);
  const addCommMember = () => {
    if (!checkIsAllFilled()) {
      setErrorPopUp("Please fill correctly all the fields.");
      setNextStep(false);
      return;
    }

    var alreadyBooked = false;
    const hasFound = members.findIndex((member) => member.email === currentUserEmail);
    if (hasFound > -1) {
      setErrorPopUp("Community member must have different email address than yours.");
      return;
    }

    const sameEmail = members.map((member) => member.email.toLowerCase()).filter((em, i, acc) => acc.indexOf(em) !== i);
    const samePhone = members.map((member) => member.phone.toLowerCase()).filter((ph, i, acc) => acc.indexOf(ph) !== i);
    if (sameEmail.length || samePhone.length) {
      setErrorPopUp("Every support member must have different email address and phone number.");
      return false;
    }

    var saveMembers = [];
    for (var member of members) {
      if (member.firstName.length > 0 && member.lastName.length > 0 && member.email.length > 0 && member.phone.length > 0) {
        saveMembers.push(member);
      }
    }

    axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
    axios
      .post(window.ajaxLink + "profile/addInitialCommunityMembers", { members: saveMembers })
      .then((res) => {
        if (res.data.responseCode === 200) {
          if (!alreadyBooked) {
            if (alreadyHasMembersLength < res.data.responseData.length) {
              setNextStep(true);
            }
            alreadyBooked = true;
            //props.bookAppointmentFromComm();
            if (alreadyHasMembers) {
              if (alreadyHasMembersLength >= res.data.responseData.length) {
                setSuccPopUp("Support Members updated successfully.");
              }
            }
            setPopUp(false);
            setEditingIndex(null);
          }
        }
      })
      .catch((error) => {
        if (error.response.data.errorData === "You have already reached maximum community member count!") {
          setErrorPopUp(error.response.data.errorData);
        }
        console.error(error);
      });
  };

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
    axios
      .post(window.ajaxLink + "profile/checkCommunityMembers", {})
      .then((res) => {
        if (res.data.responseData) {
          let response = res.data.responseData[0];
          setAlreadyHasMembersLenght(res.data.responseData[0].length);
          let currentUserEmailData = res.data.responseData[1];

          setAlreadyHasMembers(!!res.data.responseData[0].length);

          if (response && response.length > 0) {
            setMembers([...response]);
          }

          setCurrentUserEmail(currentUserEmailData);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [popUp]);

  const openDeleteModal = (i) => {
    const isReadonly = editingIndex !== null && editingIndex === i;
    if (!isReadonly) {
      setMemberToDelete(i);
      setDeleteModalVisible(true);
    } else {
      setErrorPopUp("Please save the changes before deleting the member.");
    }
  };

  const closeDeleteModal = () => {
    setDeleteModalVisible(false);
    setMemberToDelete(null);
  };

  const handleDeleteCommunityMember = () => {
    if (memberToDelete !== null) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios.post(window.ajaxLink + "profile/deleteCommunityMember", { email: members[memberToDelete].email }).then((res) => {
        if (res.data.responseData) {
          setPopUp(false);
          const communityMembersArr = [...members];
          communityMembersArr.splice(memberToDelete, 1);

          if (communityMembersArr.length === 0) {
            communityMembersArr.push({ firstName: "", lastName: "", email: "", phone: "" });
          }
          setMembers(communityMembersArr);
          closeDeleteModal();
          setSuccPopUp("Member is deleted Successfully!");
        } else {
          setErrorPopUp("Member is already Deleted!");
        }
      });
    }
  };

  // const handleEditCommunityMember = (i) => {
  //   const updatedMembers = [...members];
  //   const memberToEdit = updatedMembers[i];
  //   setMembers(updatedMembers);
  //   setEditMember(true);
  //   console.log(editMember);
  // };

  const handleEditCommunityMember = (i) => {
    setEditingIndex(i);
  };

  const handleSaveCommunityMember = (i) => {
    setEditingIndex(null);
  };

  return (
    <>
      {isLandingPage === false && (
        <div>
          <div className="ab_title add_comm_title">
            <div className="landing_stepc">Step 2</div>Invite family to join your rehab journey!
          </div>
          <div className="add_comm_container">
            <div className="header_text_involve">
              Involve your friends and family to <br /> <span className="header_text_span">improve overall program outcome and recovery by 25%</span>
            </div>
            <div className="source_text">*Source: University of Pittsburgh Medical Center Study</div>
            <div className="add_comm_checked_and_text_container">
              <div className="add_comm_checked add_comm_checked1"></div>
              <div className="add_comm_text_next_to_checked">Supportive Environment</div>
            </div>
            <div className="add_comm_checked_and_text_container">
              <div className="add_comm_checked add_comm_checked2"></div>
              <div className="add_comm_text_next_to_checked">Practical assistance with difficult tasks</div>
            </div>
            <div className="add_comm_checked_and_text_container">
              <div className="add_comm_checked add_comm_checked3"></div>
              <div className="add_comm_text_next_to_checked">Better Understanding</div>
            </div>
            <div className="add_comm_checked_and_text_container">
              <div className="add_comm_checked add_comm_checked4"></div>
              <div className="add_comm_text_next_to_checked">Emotional Support</div>
            </div>
            <div className="next_btn_questionare add_comm_btn" onClick={() => openClosePopUp()}>
              Add a Support Member
            </div>
          </div>
        </div>
      )}

      {popUp && (
        <div className="approval_wrapper add_comm_approval_wrapper">
          <div className="dbl_place_on_page add_comm_dbl_place">
            <div className="approval_popup add_comm_pop_up fixed_comm_media">
              <div className="ap_title">Add a Support Member</div>
              <div className="ap_explain add_comm_ap_explain">Invite family to join your rehab journey! Provide contact info to keep them updated on your appointments, tasks, and journey.</div>
              {members.map((item, i) => (
                <div key={i} className="communityMembersForm">
                  <div className="add_comm_form_container">
                    <input
                      type="text"
                      placeholder="First Name"
                      className={`gray_inputs inputsPatientLogin add_comm_inputs readOnly`}
                      onChange={(e) => changeMemberValues(i, "firstName", e.currentTarget.value)}
                      value={members[i] ? members[i].firstName : ""}
                      readOnly={editingIndex !== i && members[i] && members[i].firstName !== ""}
                      onClick={() => {
                        setEditingIndex(i);
                      }}
                    />
                    {members[i] && members[i].firstName.length > 0 && !checkParams(members[i].firstName, "firstname") && <div className="email_error_msg">{errorFirstName}</div>}
                    <input
                      type="text"
                      placeholder="Last Name"
                      className={`gray_inputs inputsPatientLogin add_comm_inputs readOnly`}
                      onChange={(e) => changeMemberValues(i, "lastName", e.currentTarget.value)}
                      value={members[i] ? members[i].lastName : ""}
                      readOnly={editingIndex !== i && members[i] && members[i].lastName !== ""}
                      onClick={() => {
                        setEditingIndex(i);
                      }}
                    />
                    {members[i] && members[i].lastName.length > 0 && !checkParams(members[i].lastName, "lastname") && <div className="email_error_msg">{errorLastName}</div>}
                    <input
                      type="text"
                      placeholder="Email"
                      className={`gray_inputs inputsPatientLogin add_comm_inputs readOnly`}
                      onChange={(e) => changeMemberValues(i, "email", e.currentTarget.value)}
                      value={members[i] ? members[i].email : ""}
                      readOnly={editingIndex !== i && members[i] && members[i].email !== ""}
                      onClick={() => {
                        setEditingIndex(i);
                      }}
                    />
                    {members[i] && members[i].email.length > 0 && !checkParams(members[i].email, "email") && <div className="email_error_msg">{errorEmail}</div>}
                    <input
                      type="text"
                      placeholder="Phone number"
                      className={`gray_inputs inputsPatientLogin add_comm_inputs readOnly`}
                      onChange={(e) => changeMemberValues(i, "phone", e.currentTarget.value)}
                      value={members[i] ? members[i].phone : ""}
                      readOnly={editingIndex !== i && members[i] && members[i].phone !== ""}
                      onClick={() => {
                        setEditingIndex(i);
                      }}
                    />
                    {members[i] && members[i].phone.length > 0 && !/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(members[i].phone) && <div className="email_error_msg">{errorPhone}</div>}
                    {members.length > 1 && members.length - 1 > i ? <div className="add_comm_divider"></div> : ""}

                    {/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(members[i].phone) && members[i] && checkParams(members[i].email, "email") && members[i] && checkParams(members[i].lastName, "lastname") && members[i] && checkParams(members[i].firstName, "firstname") && members.length < 3 && members.length - 1 === i ? (
                      <div
                        className="add_comm_later add_comm_another_member"
                        onClick={() => {
                          addAnotherMember();
                          setEditingIndex(null);
                        }}
                      >
                        Add another memeber
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  {members.length >= 1 && (
                    <div>
                      {members[i].firstName.length >= 2 && members[i].lastName.length >= 2 && members[i].email.length >= 8 && members[i].phone.length >= 10 && <div className="deleteCommunityMember addCommunityMemberBtn" onClick={() => openDeleteModal(i)}></div>}
                      {editingIndex === i ? <div className="saveCommunityMember addCommunityMemberBtn" onClick={() => handleSaveCommunityMember(i)}></div> : <div className="editCommunityMember addCommunityMemberBtn" onClick={() => handleEditCommunityMember(i)}></div>}
                    </div>
                  )}
                </div>
              ))}
              <div className="add_comm_button_holder">
                <div className="add_comm_cancel_btn add_comm_cancel_media" onClick={() => openClosePopUp()}>
                  Cancel
                </div>
                {!alreadyHasMembers ? (
                  <div className="next_btn_questionare add_comm_btn add_comm_confirm_btn add_comm_button_media" onClick={() => addCommMember()}>
                    Add to Support
                  </div>
                ) : (
                  <div className="next_btn_questionare add_comm_btn add_comm_confirm_btn add_comm_button_media" onClick={() => addCommMember()}>
                    Save
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {deleteModalVisible && (
        <div className="dlt_wrapper">
          <div className="dbl_place_on_page">
            <div className="dlt_surround">
              <div className="dlt_title">Delete Member</div>
              <div className="dlt_description">
                <p>Do you want to delete this member?</p>
              </div>
              <div className="dlt_exit_btm">
                <div className="dlt_exit_btn dlt_eb_first" onClick={closeDeleteModal}>
                  No
                </div>
                <div className="dlt_exit_btn dlt_eb_scnd" onClick={handleDeleteCommunityMember}>
                  Yes
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {nextStep && commPopUp === false && (
        <div className="approval_wrapper">
          <div className="approval_close" onClick={() => openCloseCommPopUp()}></div>
          <div className="dbl_place_on_page">
            <div className="approval_popup">
              <div className="ap_title">Your support member has been added and will be notified!</div>
              <div className="next_btn_questionare add_comm_btn add_comm_confirm_btn added_comm_btn" style={{ display: "block" }} onClick={() => openCloseCommPopUp()}>
                Ok, Thanks!
              </div>
            </div>
          </div>
        </div>
      )}
      {succPopUp && (
        <div className="prog_err_hold prog_pop_pat_correct">
          <div className="prog_pop_icon_correct prog_err_icon"></div>
          <div className="prog_err_text prog_pop_text_correct">{succPopUp}</div>
        </div>
      )}
      {errorPopUp && (
        <div className="prog_err_hold ">
          <div className="prog_err_icon"></div>
          <div className="prog_err_text ">{errorPopUp}</div>
        </div>
      )}
    </>
  );
};

export default AddCommunityMember;
